export const CONFIG_FRAGMENT = `
config {
    entries {
      key
      value
    }
	}
`;
